import Icon from "@ant-design/icons";
import {Image} from "antd";
import {
    MCAIconImg
} from "../../../../assets";


export const MyIcon = (props) => <Image src={MCAIconImg} preview={false}/>
